module.exports = __webpack_public_path__ + "img/skinmask_step1.90b13208.jpg";